// Mirror lato frontend di cat-plugin/aenergiafacile_plugin/wizard_config.py.
// Aggiungere mercato/segmento/operazione = una riga qui + una riga in Python.

export type WizardChoice = {
  id: string;
  label: string;
  description?: string;
  icon: string;     // nome icona Lucide
  iconBg: string;   // classe tailwind
  iconFg: string;   // classe tailwind
};

export type OperationChoice = WizardChoice & { intent: "cambio_fornitore" | "cerca_offerte" };

export const SEGMENTI: WizardChoice[] = [
  {
    id: "privato",
    label: "Privato",
    description: "Persona fisica · domestico",
    icon: "User",
    iconBg: "bg-[#4B9B2B]/10",
    iconFg: "text-[#4B9B2B]",
  },
  {
    id: "business",
    label: "Business",
    description: "P.IVA · azienda · professionista",
    icon: "Building2",
    iconBg: "bg-violet-100",
    iconFg: "text-violet-700",
  },
];

export const MERCATI: WizardChoice[] = [
  { id: "luce", label: "Luce", icon: "Lightbulb", iconBg: "bg-amber-100", iconFg: "text-amber-600" },
  { id: "gas",  label: "Gas",  icon: "Flame",     iconBg: "bg-red-100",   iconFg: "text-red-600" },
];

export const OPERAZIONI: OperationChoice[] = [
  {
    id: "switch",
    label: "Cambio fornitore",
    description: "Cliente ha già fornitura, cambia brand",
    icon: "Repeat",
    iconBg: "bg-[#4B9B2B]/10",
    iconFg: "text-[#4B9B2B]",
    intent: "cambio_fornitore",
  },
  {
    id: "voltura",
    label: "Switch/Voltura",
    description: "Cambio intestatario con fornitura attiva",
    icon: "UserCheck",
    iconBg: "bg-slate-100",
    iconFg: "text-slate-700",
    intent: "cambio_fornitore",
  },
  {
    id: "subentro",
    label: "Subentro",
    description: "Riattivazione di un contatore esistente (stesso POD)",
    icon: "Plug",
    iconBg: "bg-slate-100",
    iconFg: "text-slate-700",
    intent: "cambio_fornitore",
  },
  {
    id: "attivazione",
    label: "Nuova attivazione",
    description: "Primo allaccio · contatore mai attivato",
    icon: "Zap",
    iconBg: "bg-slate-100",
    iconFg: "text-slate-700",
    intent: "cambio_fornitore",
  },
  {
    id: "analisi",
    label: "Analisi bolletta",
    description: "Confronto e consulenza senza obbligo",
    icon: "FileSearch",
    iconBg: "bg-slate-100",
    iconFg: "text-slate-700",
    intent: "cerca_offerte",
  },
];

export const COMPAT: Record<string, { mercati: string[]; operazioni: string[] }> = {
  privato:  { mercati: ["luce", "gas"], operazioni: ["switch", "voltura", "subentro", "attivazione", "analisi"] },
  business: { mercati: ["luce", "gas"], operazioni: ["switch", "voltura", "subentro", "attivazione", "analisi"] },
};

// Sottotipo del cliente Business, scelto nella stessa schermata. Specchio di
// cat-plugin/aenergiafacile_plugin/wizard_config.py (SOTTOTIPI_BUSINESS). Aggiungere un
// sottotipo (es. Condominio) = una riga qui + una in Python + la riga A2A nel backend.
export type SottotipoChoice = WizardChoice & { tipoSoggetto: string };

export const SOTTOTIPI_BUSINESS: SottotipoChoice[] = [
  { id: "ditta", label: "Ditta individuale", description: "Titolare con P.IVA",
    icon: "UserCog", iconBg: "bg-violet-100", iconFg: "text-violet-700", tipoSoggetto: "Ditta individuale" },
  { id: "societa", label: "Società", description: "SRL, SNC, SPA, cooperativa…",
    icon: "Building2", iconBg: "bg-violet-100", iconFg: "text-violet-700", tipoSoggetto: "Società" },
  { id: "associazione", label: "Associazione", description: "Onlus · ASD · parrocchia · comitato",
    icon: "HeartHandshake", iconBg: "bg-violet-100", iconFg: "text-violet-700", tipoSoggetto: "Associazione" },
];

export type WizardPayload = {
  segmento: string;
  mercato: string;
  operazione: string;
  bolletta_uploaded: boolean;
  documento_uploaded: boolean;
  recapito: string;  // "Cartacea" | "Email"
  tipo_soggetto?: string;
  // Recapiti del cliente, facoltativi: se presenti la chat non li richiede,
  // se assenti li chiede come sempre. Già normalizzati (vedi recapiti.ts).
  telefono?: string;
  email?: string;
};
